class MobileSearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = null;
    this.panel = null;
    this.opener = null;
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-mobile-search-overlay]');
    this.panel = this.querySelector('[data-mobile-search-panel]');

    this.overlay?.addEventListener('click', this.onOverlayClick);
    this.querySelectorAll('[data-mobile-search-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close(true));
    });
  }

  disconnectedCallback() {
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    document.removeEventListener('keyup', this.onKeyup);
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  onOverlayClick(event) {
    if (event.target === this.overlay) this.close(true);
  }

  onKeyup(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close(true);
  }

  open(trigger) {
    if (this.isOpen()) return;
    this.opener = trigger || null;
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keyup', this.onKeyup);
    requestAnimationFrame(() => {
      this.classList.add('mobile-search-drawer--animating');
    });
  }

  close(returnFocus = true) {
    if (!this.isOpen()) return;
    document.removeEventListener('keyup', this.onKeyup);
    document.body.classList.remove('overflow-hidden');

    const opener = returnFocus ? this.opener : null;
    removeTrapFocus(opener);
    this.opener = null;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.remove('mobile-search-drawer--animating');
      this.removeAttribute('open');
      return;
    }

    this.classList.remove('mobile-search-drawer--animating');

    const finishClose = () => {
      this.removeAttribute('open');
    };

    const handleTransitionEnd = (e) => {
      if (e.target !== this.panel || e.propertyName !== 'transform') return;
      this.panel.removeEventListener('transitionend', handleTransitionEnd);
      clearTimeout(fallbackTimer);
      finishClose();
    };

    let fallbackTimer;
    if (this.panel) {
      this.panel.addEventListener('transitionend', handleTransitionEnd);
      fallbackTimer = setTimeout(() => {
        this.panel.removeEventListener('transitionend', handleTransitionEnd);
        finishClose();
      }, 400);
    } else {
      finishClose();
    }
  }
}

customElements.define('mobile-search-drawer', MobileSearchDrawer);

if (!window.__apiceMobileSearchOpenBound) {
  window.__apiceMobileSearchOpenBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-open-mobile-search]');
    if (!trigger) return;
    event.preventDefault();
    document.querySelector('mobile-search-drawer')?.open(trigger);
  });
}
